import styled from "styled-components"

export const Button = styled.button`
  background-color: ${(props) => props.background};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding};
  border: ${(props) => props.border};
  /* border-radius: 4px; */
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color};
`
